<template>
    <div class="listDetails">
        <div class="header_box">
        <!-- 头部搜索框 -->
            <div class="search">
                <input type="text" class="search_key" :placeholder="formData.hold" v-model="formData.inputParams" />
                <span class="search_btn" @click="startSearch">查询</span>
                <img src="../../../../../assets/image/search.png" class="search_img" />
            </div>
        </div>
        <div :class="isNolist ? 'top_title_active':'top_title'"  ref="wrapper1">
            <div class="wrapper1">
                <div
                :class=" dafaultType == 1 ? 'item_active' : 'item_active1'"
                @click="getlist(1)"
                >
                    <p class="p_active">{{cityList1[0].areaName}}</p>
                    <p>
                        <span class="t_active">{{cityList.province||0}}</span>
                        <span class="t_active">起</span>
                    </p>
                </div>
                <div
                :class=" dafaultType == 2 ? 'item_active' : 'item_active1'"
                @click="getlist(2)"
                >
                    <p class="p_active">{{cityList1[1].areaName}}</p>
                    <p>
                        <span class="t_active">{{cityList.city||0}}</span>
                        <span class="t_active">起</span>
                    </p>
                </div>
                <div
                :class=" dafaultType == 3 ? 'item_active' : 'item_active1'"
                @click="getlist(3)"
                >
                    <p class="p_active">{{cityList1[2].areaName}}</p>
                    <p>
                        <span class="t_active">{{cityList.county||0}}</span>
                        <span class="t_active">起</span>
                    </p>
                </div>
                <div
                :class=" dafaultType == 4 ? 'item_active' : 'item_active1'"
                @click="getlist(4)"
                >
                    <p class="p_active">{{cityList1[3].areaName}}</p>
                    <p>
                        <span class="t_active">{{cityList.enterprise||0}}</span>
                        <span class="t_active">起</span>
                    </p>
                </div>
            </div>
        </div>

        <div class="content_list" v-if="cityList !== null && cityList.length !== 0 && proList.length !== 0">
            <van-list
                ref="vanList"
                v-model="loading"
                :finished="finished"
                :finished-text="finishedText"
                :immediate-check="false"
                @load="onLoad"
                class="wrapper"
            >
                <div
                class="reject"
                v-for="(item,index) in proList"
                :key="index"
                @click="goDetail(item)"
                >
                <div class="reject_item">
                    <div class="box_item">
                        <div class="title">
                          <p class="title_text">{{item.defendantName}}</p>
                          <p
                            class="title_tag1"
                            :class="sstt[item.urgencyDegree == '' ? '': Number(item.urgencyDegree-7)]"
                            >{{sttText[item.urgencyDegree == '' ? '': Number(item.urgencyDegree-7)]}}</p>
                        </div>
                        <div class="info1">
                            <span><img src="../../../../../assets/complaint/adress.png" alt=""></span><span>{{item.belongMechanismName}}</span>
                        </div>
                        <div class="info">
                            <span>投诉人姓名:</span>
                            <span>{{item.complainName}}</span>
                        </div>
                        <div class="info">
                            <span>投诉时间:</span>
                            <span>{{item.complainTime}}</span>
                        </div>
                        <div class="info">
                            <span>投诉单号:</span>
                            <span>{{item.mainComplainNumber}}</span>
                        </div>
                        <div class="info">
                            <span>处置状态:</span>
                            <span class="info_time">{{item.handleTime|filt3()}}</span>
                            <span></span>
                            <span>{{item.handleTimeLimit|filt4()}}</span>
                        </div>
                    </div>
                    <div class="line line_bottom"></div>
                    <div class="status">
                        <p>
                            <span>查看详情</span>
                            <span>
                                <img src="../../../../../assets/image/right.png" alt="">
                            </span>
                        </p>
                    </div>
                </div>
                <!-- <div class="space"></div> -->
                </div>
            </van-list>
        </div>
        <isNoInfo :isNolist="isNolist"></isNoInfo>
    </div>
</template>
<script>
    import api from '../../../../../service/modules/complaintApis';
    import isNoInfo from '../../../../../components/isNoInfo.vue';
    import util from '../../../../../utils/common'
    import moment from 'moment';
    export default {
        components: {
            isNoInfo
        },
        data () {
            return {
                isHide: false,
                isShow: false,
                ischange: true,
                pageIndex: '0',
                pageSize: '10',
                proList: [],
                cityList: {},
                cityList1: [
                    { areaName: '省级' },
                    { areaName: '州市' },
                    { areaName: '区县' },
                    { areaName: '企业' }
                ],
                finished: false,
                finishedText: '没有更多',
                loading: false,
                isNolist: false,
                total: '0',
                totalPrice: '0',
                status: '',
                timer: null,
                scrollY: 0,
                cityName: '',
                cover: 1,
                sstt: [
                    'ss1',
                    'ss2',
                    'ss3'
                ],
                sttText: [
                    '一般',
                    '较重',
                    '严重'
                ],
                typeSign: this.$route.query.typeSign,
                dafaultType: this.$route.query.dafaultType,
                areaOne: this.$route.query.areaOne,
                formData:{
                    inputParams:'',
                    hold:'投诉单号/投诉人姓名/被投诉对象名称',
                }
            }
        },
        created () {
            this.getInfoList();
        },
        mounted () {
        },
        methods: {
            startSearch(){
                this.getlist(this.dafaultType);
            },
            getInfoList () {
                api.leader.getCountByPlace({
                    areaOne: this.areaOne
                }).then(res => {
                    if (res.ret === 0) {
                        if (res.data.dropDistribution) {
                            this.cityList = res.data.dropDistribution;
                            this.isNolist = false;
                            this.loading = false;
                        } else {
                            this.loading = false;
                            this.isNolist = true;
                            this.finishedText = '';
                        }
                        this.getlist(this.dafaultType);
                    } else {
                        this.isNolist = true;
                        this.loading = false;
                        this.finished = true;
                        this.finishedText = '';
                        this.cityList = res.data.dropDistribution;
                    }
                });
            },

            goDetail (value) {
                this.$router.push({
                    name: 'workListDetails',
                    params: {
                        item: value
                    }
                });
                util.setJsonLocal('item', value);
                this.$store.commit('complaint/getItemList', value);
                this.$store.commit('complaint/setCheckList', false);
            },
            getlist (value) {
                this.dafaultType = value;
                this.proList = [];
                this.pageIndex = 1;
                const data = {
                    curPage: this.pageIndex,
                    pageSize: 10,
                    type: this.typeSign,
                    inputParams: this.formData.inputParams,
                    place: this.areaOne,
                    pointType: this.dafaultType
                }
                api.common.getDropDistributionList(data).then(res => {
                    this.loading = false; // 加载参数
                    this.finishedText = '没有更多';
                    const list = (res.data || {}).list || [];
                    if (list.length > 0 && this.cityList !== null && this.cityList.length !== 0) { // 有数据
                        this.proList = list;
                        if (list.length === res.data.totalSize) { // 已加载完了
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                        this.isNolist = false;
                    } else {
                        this.finished = true;
                        this.loading = false;
                        this.isNolist = true;
                        this.finishedText = '';
                    }
                })
            },
            getMore () {
                const data = {
                    curPage: this.pageIndex,
                    pageSize: 10,
                    type: this.typeSign,
                    inputParams: '',
                    place: this.areaOne,
                    pointType: this.dafaultType
                }
                api.common.getDropDistributionList(data).then((res) => {
                    const list = (res.data || {}).list || [];
                    if (list.length > 0) { // 有数据
                        this.proList = this.proList.concat(list);
                        if (this.proList.length === res.data.totalSize) {
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                    }
                })
            },
            onLoad () {
                this.pageIndex++;
                this.getMore();
            }
        },
        filters: {
            filt (value) {
                return moment(value).format('YYYY-MM-DD HH:mm:ss');
            },
            filt1 (value) {
                var config = util.getJsonLocal('configList').PRODUCT_TYPE;
                let name = '';
                config.map((item, index) => {
                    if (item.code === value) {
                        name = item.name;
                    }
                });
                return name;
            },
            filt2 (value) {
                var config = util.getJsonLocal('configList').WORK_ORDER_FLOW;
                let name = '';
                config.map((item, index) => {
                    if (item.code === value) {
                        name = item.name;
                    }
                });
                return name;
            },
            // 时长计算
            filt3 (value) {
                var theTime = parseInt(value);// 秒
                var middle= 0;// 分
                var hour= 0;// 小时

                if(theTime > 60) {
                    middle= parseInt(theTime/60);
                    theTime = parseInt(theTime%60);
                    if(middle> 60) {
                        hour= parseInt(middle/60);
                        middle= parseInt(middle%60);
                    }
                }
                var result = ""+parseInt(theTime)+"秒";
                if(middle > 0) {
                    result = ""+parseInt(middle)+"分"+result;
                }
                if(hour> 0) {
                    result = ""+parseInt(hour)+"小时"+result;
                }
                return result;
            },
            // 计算时限
            filt4 (str) {
                let duration = str;
                let zero = function (times) {
                    return times;
                };
                let hour = zero(Math.floor(duration / 3600));
                let minutes = zero(Math.ceil((duration / 60) % 60));
                let times = '';
                if (hour > 0) {
                    times += hour + 'h';
                }
                if (minutes > 0) {
                    times += minutes + 'm';
                }
                return times;
            }
        }
    }
</script>
<style lang="less" scoped>
.listDetails {
    width:100%;
    height:100%;
    background-color: #FBFBFB;
    .header_box {
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 10;
        background-color: #fff;
        .search {
        width: 100%;
        position: relative;
        margin-top: 10px;
        margin-bottom: 10px;
        .search_key {
            width: 297px;
            height: 36px;
            background: #f8f8f8;
            border-radius: 18px;
            margin-left: 15px;
            font-size: 13px !important;
            padding-left: 39px;
            box-sizing: border-box;
            border: 0;
            outline: none;
            line-height: 36px;
        }
        .search_btn {
            font-size: 14px;
            margin-left: 16px;
        }
        .search_img {
            width: 15px;
            height: 14px;
            position: absolute;
            left: 30px;
            top: 11px;
        }
        }
        .search_query {
        width: 100%;
        height: 42px;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        -webkit-flex-direction: row;
        border-bottom: 1px solid #eee;
        .item {
            flex: 1;
            text-align: center;
            line-height: 42px;
            .city {
            display: inline-block;
            vertical-align: middle;
            font-size: 12px;
            color: #666;
            max-width: 110px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            }
            .jian {
            width: 6px;
            height: 4px;
            display: inline-block;
            vertical-align: middle;
            }
        }
        }
    }
    .top_title {
        width: 100%;
        height: 100px;
        overflow: hidden;
        position: fixed;
        top:56px;
        left:0;
        background-color: #fff;
        z-index: 2;
        box-sizing: border-box;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.04);
        .wrapper1 {
            white-space: nowrap;
            top: 0;
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin-top: 20px;
            padding: 0 20px;
            .item_active {
                background-color: #36b374;
                width: 70px;
                height: 52px;
                padding: 8px 0;
                border-radius: 5px;
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 12px;
                p {
                    height: 16px;
                    color: #fff;
                }
            }
            .item_active1 {
                background-color: #fff;
                width: 70px;
                height: 52px;
                padding: 8px 0;
                border-radius: 5px;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
                border: 1px solid #efefef;
                p {
                    height: 16px;
                    color: #999999
                }
            }
        }
    }
    .top_title_active {
        width: 100%;
        height: 100px;
        overflow: hidden;
        background-color: #fff;
        z-index: 2;
        position: fixed;
        top:58px;
        box-sizing: border-box;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.04);
        .wrapper1 {
            white-space: nowrap;
            top: 0;
            display: flex;
            justify-content: space-around;
            align-items: center;
            margin-top: 20px;
            padding: 0 20px;
            .item_active {
                background-color: #36b374;
                width: 70px;
                height: 52px;
                padding: 8px 0;
                border-radius: 5px;
                text-align: center;
                line-height: 20px;
                color: #fff;
                font-size: 12px;
                p {
                    height: 16px;
                    color: #fff;
                }
            }
            .item_active1 {
                background-color: #fff;
                width: 70px;
                height: 52px;
                padding: 8px 0;
                border-radius: 5px;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
                border: 1px solid #efefef;
                p {
                    height: 16px;
                    color: #999999
                }
            }
        }
    }
    .content_list {
        width: 100%;
        height: 100%;
        .wrapper {
            padding-top: 176px;
        }
        .s_city {
            width: 100%;
            text-align: center;
            border-bottom: 1px solid #efefef;
            margin-top: 20px;
            img {
                display: inline-block;
                width: 48px;
                height: 14px;
            }
        }
        .reject {
        width: 100%;
        background-color: @base-background;
        padding-bottom: 16px;
        .reject_item {
            margin-left: 12px;
            margin-right: 12px;
            padding-bottom: 0;
            box-sizing: border-box;
            background-color: #ffffff;
            box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
            border-radius: 3px;
            .box_item{
                width:100%;
                padding: 16px;
                box-sizing: border-box;
                .title {
                    display: flex;
                        justify-content: space-between;
                        .title_text {
                            font-size: 16px;
                            font-weight: 700;
                            color: #2a2a2a;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            white-space: nowrap;
                            line-height: 20px;
                        }
                        .title_tag {
                            width: 36px;
                            height: 18px;
                            font-size: 10px;
                            color: #ffffff;
                            border-radius: 9px;
                            text-align: center;
                            line-height: 18px;
                    }
                    .ss1{
                        background: #118BF5;
                    }
                    .ss2{
                        background: #FFA509;
                    }
                    .ss3{
                        background: #F75C32;
                    }
                }

                .info {
                    margin-top: 12px;
                    span:nth-child(1) {
                        display: inline-block;
                        width: 84px;
                        font-size: 14px;
                        color: #777;
                    }
                    span:nth-child(2) {
                        display: inline-block;
                        font-size: 14px;
                    }
                    span:nth-child(3) {
                        display: inline-block;
                        content: '';
                        margin: -8px 5px;
                        background: #999;
                        width: 1px;
                        height: 16px;
                        -webkit-transform: scaleY(0.5);
                        transform: scale(0.5);
                        -webkit-transform-origin: 0 0;
                        transform-origin: 0 0;
                    }
                    span {
                        font-size: 14px;
                        color: #777;

                    }
                    .info_time {
                        color: #36B374;
                    }
                }
                .info1 {
                    margin-top: 12px;
                    display: flex;
                    align-items: center;
                    img {
                        width: 14px;
                        margin-top:-2px;
                    }
                    span:nth-child(2) {
                        font-size:14px;
                        font-weight:400;
                        color:rgba(143,143,143,1);
                        line-height:14px;
                        margin-left:3px;
                    }

                }
            }
            .line {
                width: 100%;
                height: 1px;
                margin-top: 2px;
            }
            .status {
                width: 100%;
                padding: 15px 0;
                font-size: 14px;
                color: #333333;
                font-weight: 400;
                display: flex;
                justify-content: center;
                p   {
                    display: flex;
                    align-items: center;
                    span {
                        color: #999999;
                        font-size: 12px;
                    }
                }
                p>span>img {
                    width: 4px;
                    height: 7px;
                    margin-left: 4px;
                    margin-top:-3px;
                }
            }
        }
            .space {
                width: 100%;
                height: 24px;
                background-color: #fafafa;
            }
        }
    }
    .box1 {
        text-align: center;
        padding-top: 64px;
        img {
            display: inline-block;
            width: 155px;
            height: 155px;
        }
        .tip1 {
            font-size: 14px;
            color: #9b9b9b;
            margin-top: 28px;
        }
        .tip2 {
            font-size: 14px;
            color: #9b9b9b;
            margin-top: 8px;
        }
    }
}
</style>
